var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-canvas"},[_c('canvas',{attrs:{"id":"canvas","width":_vm.width,"height":_vm.height},on:{"click":_vm.handleDraw}})])
}
var staticRenderFns = []

export { render, staticRenderFns }